var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-tag',{class:`mx-0 ${_vm.my} px-4 text-center`,staticStyle:{"font-size":"13px","width":"100%"},attrs:{"type":_vm.getColorType(_vm.avgValue),"effect":"dark"}},[_c('strong',[_vm._v(_vm._s(_vm.avgValue)+" "+_vm._s(_vm.tagLabel))])])
}
var staticRenderFns = []

export { render, staticRenderFns }